import TeNavbar from './index.vue';


TeNavbar.install = function(Vue) {
  Vue.component(TeNavbar.name, TeNavbar);
};

export default TeNavbar;